<template>
    <page>
        <iframe
            ref="iframe"
            :id="iframeId"
            class="lx-calendar-tape-iframe"
            :style="{'width': iframeWidth}"
            marginheight="0"
            marginwidth="0"
            allowfullscreen="true"
            webkitallowfullscreen="true"
            :src="iframeSrc"
            @load="onIframeLoad"
        ></iframe>
    </page>
</template>

<script>
    import Page from '../../generic/page/page.vue';
    import { removeScrollMixin } from '../../../mixins/remove-scroll-mixin';

    export default {
        name: 'CalendarTapeView',
        components: {
            Page,
        },
        mixins: [removeScrollMixin],
        data: function() {
            return {
                pageHeight: 0,
                iframeId: 'lx-calendar-tape',
                iframeEl: null,
                iframeWidth: '100%',
            };
        },
        computed: {
            iframeSrc() {
                const rand = Math.random();
                return `/booking-calendar/availability/?iframe=${this.iframeId}&v=${rand}`;
            },
        },
        methods: {
            onIframeLoad() {
                let width = 0;
                const doc = window.document;
                const fullscreenElement =
                    doc.fullscreenElement ||
                    doc.webkitFullscreenElement ||
                    doc.mozFullScreenElement ||
                    doc.msFullscreenElement;
                if (fullscreenElement && fullscreenElement.id === this.iframeId) {
                    width = window.screen.width;
                    this.pageHeight = window.screen.height;
                } else {
                    // Get available width
                    var rect = this.iframeEl.parentNode.getBoundingClientRect();
                    width = rect.width;
                    this.pageHeight = rect.height;
                }
                this.iframeWidth = `${width}px`;
                // Send new width to the iframe
                if (this.iframeEl.contentWindow) {
                    this.iframeEl.contentWindow.postMessage(
                        'width=' + width,
                        document.location.origin
                    );
                }
            },
        },
        mounted() {
            this.iframeEl = this.$refs.iframe;
            window.addEventListener('resize', this.onIframeLoad);
        },
        beforeUnmount() {
            window.removeEventListener('resize', this.onIframeLoad);
        },
    };
</script>

<style lang="scss" scoped>
    .lx-calendar-tape-iframe {
        position: absolute;
        left: 0;
        top: 0;
        margin: 7px 0 0 0;
        border: 0;
        height: calc(100% - 7px);
    }
</style>
